import { reenrolmentApi } from './clients';
import { queryClient } from './queryClient';

export const PARENT_HISTORY_STALE_TIME = 5 * 60 * 1000;

export const parentHistoryKeys = {
    all: ['parentHistory'],
    byParentCode: (parentCode) => [...parentHistoryKeys.all, parentCode],
};

/**
 * Fetches parent history via reenrolment backend (proxies AIC Connect).
 * @returns {object|string} parent object, or 'No children found'
 */
export const fetchParentHistory = async (parentCode) => {
    const { data } = await reenrolmentApi.get('/parent/get-parent-history', {
        params: { parent_code: parentCode },
    });

    const parent = data?.parent;
    const hasStudents = parent?.parent_codes?.some(
        (campus) => Array.isArray(campus.students) && campus.students.length > 0
    );

    if (!parent || !hasStudents) {
        return 'No children found';
    }

    return parent;
};

/** Same cache as useParentHistory — does not hit the API when data is still fresh. */
export const fetchCachedParentHistory = (parentCode) =>
    queryClient.fetchQuery({
        queryKey: parentHistoryKeys.byParentCode(parentCode),
        queryFn: () => fetchParentHistory(parentCode),
        staleTime: PARENT_HISTORY_STALE_TIME,
    });

export default fetchParentHistory;
